module.exports = __webpack_public_path__ + "media/images/sandbox/megaman-5eaa07d0b4c44f7fedd1c40e5a66783e.png";